export default function () {
  const toSystemFriendlyString = (s: string) => {
    return s
      .replace(/[^a-z0-9_]+/gi, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase()
  }
  const getPflegeColornameFromHex = (hex: string | undefined) => {
    switch (hex) {
      case '#ffffff':
      case '#fff':
      case '#ffff':
      case '#ffffffff':
        return 'white'
      case '#f1f7f7':
      case '#f1f7f7ff':
        return 'mint-lightest'
      case '#f2f2f2':
      case '#0000000d':
        return 'neutral-5'
      default:
        return null
    }
  }

  return {
    toSystemFriendlyString,
    getPflegeColornameFromHex,
  }
}
